export default __webpack_public_path__ + "static/media/labyrinthen-floorplan-G1.a66c6a6b.jpg";